export default __webpack_public_path__ + "static/principle-integrated-light-0bde98c64c0588146ceaf7449a7cba0cf561a9ef1b1e06dbbb1b07c61663d3bc.png";